<template>
  <div>
    <HighBoard @logOut="logOutClick" @clickWiki="openPageWiki" @clickCompany="openPageCompany"
      @clickDashboard="openPageDashboard" @clickModem="openPageModem" @openNotification="openNotification" :username="userOptions.username"
      :role="userOptions.role"
    />
    
    <!-- <div class="app-container" @click="closeAllWindow"> -->
    <component :is="activeComponent"></component>
    <Transition name="fade" mode="out-in">
      <Notifications v-if="windowShadow" @closeWindow="closeWindow" class="notifications-overlay" />
    </Transition>

    <!-- </div> -->
  </div>
</template>

<script>
import { shallowRef } from 'vue'
import { mapGetters, mapActions } from 'vuex'
import DashboardVue from '@/pages/dashboard/DashboardPage.vue'
import CompanyVue from '@/pages/company/CompanyPage.vue'
import WikiVue from '@/pages/wiki/WikiPage.vue'
import HighBoard from '@/components/HighBoard.vue'
import Notifications from '@/components/Notifications.vue'
import ModemVue from '@/pages/modem/ModemPage.vue'

export default {
  name: 'WindowDashboard',
  computed: {
    ...mapGetters('user', {
      userOptions: 'getUserOptions',
    })
  },
  data() {
    return {
      windowShadow: false,
      activeComponent: shallowRef(DashboardVue),
    }
  },
  components: {
    DashboardVue,
    CompanyVue,
    HighBoard,
    WikiVue,
    Notifications,
    ModemVue
  },
  methods: {
    ...mapActions('user', {
      postLogout: 'postLogout',
    }),
    logOutClick() {
      this.postLogout()
    },
    closeWindow() {
      this.windowShadow = false
    },
    openNotification() {
      this.windowShadow = !this.windowShadow
    },
    openPageCompany() {
      this.activeComponent = shallowRef(CompanyVue)
    },
    openPageDashboard() {
      this.activeComponent = shallowRef(DashboardVue)
    },
    openPageWiki() {
      this.activeComponent = shallowRef(WikiVue)
    },
    openPageModem() {
      this.activeComponent = shallowRef(ModemVue)
    },
    closeAllWindow() {
      this.windowShadow = false
      console.log('closeAllWindow')
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  // position: relative;
}

.main-content {
  // position: relative;

}

.notifications-overlay {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 10;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
}


.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.4s ease;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.slide-fade-enter-to {
  opacity: 1;
  transform: translateX(0%);
}

.slide-fade-leave-from {
  opacity: 1;
  transform: translateX(0%);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style>
